module.exports = __webpack_public_path__ + "img/cover@2x.a49f1c6f.png";